module.exports = __webpack_public_path__ + "img/close.27b9132a.svg";